import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 text-sm text-red-600 text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-4 text-sm text-green-600 text-center"
}
const _hoisted_3 = {
  key: 2,
  class: "mt-4 text-sm text-red-600 text-center"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormMessages',
  props: {
    formSubmitted: { type: Boolean },
    agreed: { type: Boolean },
    validationMessage: {},
    successMessage: {},
    errorMessage: {},
    showSuccessMessage: { type: Boolean },
    showErrorMessage: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.formSubmitted && !_ctx.agreed)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.validationMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.showSuccessMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.successMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.showErrorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})